module.exports = __webpack_public_path__ + "static/img/Tela de caixa.65579a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Screenshots/Tela de caixa.png
// module id = rODZ
// module chunks = 0